export default __webpack_public_path__ + "static/media/about1.4ec60e13.jpg";